import { getCookie } from '@tencent/ark-utils/lib/cookie';
var XSRF_COOKIE_KEY = 'TOK';
export var getXsrfToken = function getXsrfToken() {
  return getCookie(XSRF_COOKIE_KEY) || '';
};
//# sourceMappingURL=cookie.js.map